/**
 * Ce qui fait tomber la peur, à côté du bouton — 28/09/2026.
 *
 * En Afrique francophone, l'objection n° 1 à un achat en ligne n'est pas le
 * prix : c'est « et si je paie pour rien ? ». La garantie était déjà écrite
 * sous chaque bouton ; il manquait les deux autres réponses, **comment** on
 * paie et **quand** on reçoit. Elles vivaient plus loin, dans la fenêtre de
 * paiement — c'est-à-dire après la décision qu'elles devaient rassurer.
 *
 * Les portefeuilles sont nommés parce que ce sont ceux de l'acheteur : le
 * choix se fait sur la page de Chariow, et cette ligne annonce ce qui y sera
 * possible, elle ne route rien (arbitrage du 27/08/2026). Le délai est celui
 * qu'on tient : la rédaction prend quelques minutes, et le lien reste valable.
 */
export const MOYENS_ET_DELAI =
  "Le mobile money de votre pays — Wave, Orange, MTN, Moov, Mixx… — ou la carte · votre rapport arrive en quelques minutes, et son lien reste valable.";

export function Rassurance() {
  return (
    <p className="fine rassurance" style={{ textAlign: "center", marginTop: "4px" }}>
      {MOYENS_ET_DELAI}
    </p>
  );
}
